var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.column === "lostBenefitPercentage" &&
      _vm.bookingItem.low_fare !== null &&
      _vm.bookingItem.invoice_gross_value !== null
        ? [
            _vm._v(
              " " +
                _vm._s(
                  parseFloat(
                    (_vm.bookingItem.lost_benefit /
                      _vm.bookingItem.invoice_gross_value) *
                      100
                  ).toFixed(1)
                ) +
                " % "
            )
          ]
        : _vm._e(),
      _vm.column === "lostBenefit" && _vm.bookingItem.lost_benefit !== null
        ? [
            _vm._v(
              " " +
                _vm._s(parseFloat(_vm.bookingItem.lost_benefit).toFixed(2)) +
                " " +
                _vm._s(_vm.currency) +
                " "
            )
          ]
        : _vm._e(),
      _vm.column === "fareBase" && _vm.bookingItem.fare_base !== null
        ? [
            _vm._v(
              " " +
                _vm._s(parseFloat(_vm.bookingItem.fare_base).toFixed(2)) +
                " " +
                _vm._s(_vm.currency) +
                " "
            )
          ]
        : _vm._e(),
      _vm.column === "name"
        ? [_vm._v(" " + _vm._s(_vm.bookingItem.name) + " ")]
        : _vm._e(),
      _vm.column === "airline_name"
        ? [_vm._v(" " + _vm._s(_vm.bookingItem.airline_name) + " ")]
        : _vm._e(),
      _vm.column === "compartment"
        ? [_vm._v(" " + _vm._s(_vm.bookingItem.compartment) + " ")]
        : _vm._e(),
      _vm.column === "airline_icao"
        ? [_vm._v(" " + _vm._s(_vm.bookingItem.airline_icao) + " ")]
        : _vm._e(),
      _vm.column === "airline_iata"
        ? [_vm._v(" " + _vm._s(_vm.bookingItem.airline_iata) + " ")]
        : _vm._e(),
      _vm.column === "low_fare" && _vm.bookingItem.low_fare !== null
        ? [
            _vm._v(
              _vm._s(_vm.bookingItem.low_fare) + " " + _vm._s(_vm.currency)
            )
          ]
        : _vm._e(),
      _vm.column === "creation_date"
        ? [
            _vm._v(
              " " +
                _vm._s(_vm.formatDateView(_vm.bookingItem.creation_date)) +
                " "
            )
          ]
        : _vm._e(),
      _vm.column === "reservation_number"
        ? [
            _vm._v(" " + _vm._s(_vm.bookingItem.reservation_number) + " "),
            _vm.bookingItem.is_cancelled === 1
              ? _c(
                  "v-chip",
                  {
                    staticStyle: {
                      color: "#FFE3F3",
                      "background-color": "#ff99d0 !important"
                    },
                    attrs: { label: "", outlined: "", small: "" }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("booking.canceled")) + " ")]
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm.column === "route" && _vm.bookingItem.flightAttributes !== null
        ? [
            _vm.bookingItem.flightAttributes.start_airport_code == null
              ? _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.bookingItem.flightAttributes.itinerary) +
                      " "
                  ),
                  _c("div", { staticClass: "flight-date grey--text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("booking.flight.missingDetailedInformation")
                        ) +
                        " "
                    )
                  ])
                ])
              : _c(
                  "div",
                  [
                    _c(
                      "v-row",
                      [
                        _c("v-col", { staticClass: "flight-part" }, [
                          _c(
                            "div",
                            { staticClass: "flight-direction grey--text" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("booking.flight.departure")) +
                                  " "
                              )
                            ]
                          ),
                          _c("div", { staticClass: "flight-airport" }, [
                            _c(
                              "span",
                              {
                                staticClass: "bigger",
                                staticStyle: { "font-weight": "bold" }
                              },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", color: "white" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  {
                                                    staticClass: "accent--text"
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.bookingItem
                                                        .flightAttributes
                                                        .start_airport_code
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4111529781
                                    )
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#0f0f0f" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.bookingItem.flightAttributes
                                              .start_airport_name
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c("span", { staticClass: "arrow" }, [
                                  _vm._v("➞")
                                ]),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", color: "white" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  {
                                                    staticClass: "accent--text"
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.bookingItem
                                                        .flightAttributes
                                                        .end_airport_code
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3478564314
                                    )
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#0f0f0f" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.bookingItem.flightAttributes
                                              .end_airport_name
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.bookingItem.flightAttributes.start_time !=
                                    null
                                    ? _vm.bookingItem.flightAttributes.start_time.substr(
                                        0,
                                        5
                                      )
                                    : _vm.$t("global.noData")
                                ) +
                                " - " +
                                _vm._s(
                                  _vm.bookingItem.flightAttributes.end_time !=
                                    null
                                    ? _vm.bookingItem.flightAttributes.end_time.substr(
                                        0,
                                        5
                                      )
                                    : _vm.$t("global.noData")
                                ) +
                                " "
                            )
                          ]),
                          _c("div", { staticClass: "flight-date grey--text" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.bookingItem.flightAttributes.start_date !=
                                    null
                                    ? _vm.dayOfWeek(
                                        _vm.bookingItem.flightAttributes.start_date.substr(
                                          0,
                                          10
                                        )
                                      )
                                    : _vm.$t("global.noData")
                                ) +
                                " " +
                                _vm._s(
                                  _vm.bookingItem.flightAttributes.start_date !=
                                    null
                                    ? _vm.formatDateView(
                                        _vm.bookingItem.flightAttributes
                                          .start_date
                                      )
                                    : _vm.$t("global.noData")
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _vm.bookingItem.flightAttributes
                          .return_start_airport_code != null
                          ? _c("v-col", { staticClass: "flight-part" }, [
                              _c(
                                "div",
                                { staticClass: "flight-direction grey--text" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("booking.flight.arrival")) +
                                      " "
                                  )
                                ]
                              ),
                              _c("div", { staticClass: "flight-airport" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "bigger",
                                    staticStyle: { "font-weight": "bold" }
                                  },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "", color: "white" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "span",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "accent--text"
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bookingItem
                                                            .flightAttributes
                                                            .return_start_airport_code
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          87202240
                                        )
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#0f0f0f" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.bookingItem.flightAttributes
                                                  .return_start_airport_name
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c("span", { staticClass: "arrow" }, [
                                      _vm._v("➞")
                                    ]),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "", color: "white" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "span",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "accent--text"
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.bookingItem
                                                            .flightAttributes
                                                            .return_end_airport_code
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2863073295
                                        )
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#0f0f0f" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.bookingItem.flightAttributes
                                                  .return_end_airport_name
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.bookingItem.flightAttributes.return_start_time.substr(
                                        0,
                                        5
                                      )
                                    ) +
                                    " - " +
                                    _vm._s(
                                      _vm.bookingItem.flightAttributes.return_end_time.substr(
                                        0,
                                        5
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "flight-date grey--text" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.dayOfWeek(
                                          _vm.bookingItem.flightAttributes.return_start_date.substr(
                                            0,
                                            10
                                          )
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.formatDateView(
                                          _vm.bookingItem.flightAttributes
                                            .return_start_date
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        : _vm._e(),
      _vm.column === "ticket_number" &&
      _vm.bookingItem.flightAttributes !== null
        ? [
            _vm._v(
              " " + _vm._s(_vm.bookingItem.flightAttributes.ticket_number) + " "
            )
          ]
        : _vm._e(),
      _vm.column === "passengers"
        ? _vm._l(_vm.bookingItem.passengers, function(passenger) {
            return _c(
              "span",
              { staticStyle: { "text-transform": "capitalize" } },
              [_vm._v(" " + _vm._s(passenger) + " "), _c("br")]
            )
          })
        : _vm._e(),
      _vm.column === "sale_date"
        ? [_vm._v(" " + _vm._s(_vm.bookingItem.sale_date) + " ")]
        : _vm._e(),
      _vm.column === "issue_date"
        ? [_vm._v(" " + _vm._s(_vm.bookingItem.issue_date) + " ")]
        : _vm._e(),
      _vm.column === "invoice_number"
        ? [_vm._v(" " + _vm._s(_vm.bookingItem.invoice_number) + " ")]
        : _vm._e(),
      _vm.column === "grossSummary"
        ? [
            _c(
              "span",
              { staticClass: "datatable-total-amount" },
              [
                _vm.bookingItem.invoice_gross_value !== null
                  ? [
                      _vm._v(
                        _vm._s(
                          parseFloat(
                            _vm.bookingItem.invoice_gross_value
                          ).toFixed(2)
                        ) +
                          " " +
                          _vm._s(_vm.bookingItem.invoice_currency)
                      )
                    ]
                  : _vm.bookingItem.total_amount !== null
                  ? [
                      _vm._v(
                        _vm._s(
                          parseFloat(_vm.bookingItem.total_amount).toFixed(2)
                        ) + " PLN"
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : _vm._e(),
      _vm.column === "grossSummaryWithDiscount"
        ? [
            _c(
              "span",
              { staticClass: "datatable-total-amount" },
              [
                _vm.bookingItem.invoice_gross_with_discount !== null
                  ? [
                      _vm._v(
                        " " +
                          _vm._s(
                            parseFloat(
                              _vm.bookingItem.invoice_gross_with_discount
                            ).toFixed(2)
                          ) +
                          " " +
                          _vm._s(_vm.bookingItem.invoice_currency) +
                          " "
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : _vm._e(),
      _vm.column === "netSummary"
        ? [
            _c("span", { staticClass: "datatable-net-amount" }, [
              _vm._v(
                " " +
                  _vm._s(
                    parseFloat(_vm.bookingItem.invoice_net_value).toFixed(2)
                  ) +
                  " " +
                  _vm._s(_vm.bookingItem.invoice_currency) +
                  " "
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "discount" && _vm.bookingItem.discount !== null
        ? [
            _vm._v(
              " " +
                _vm._s(parseFloat(_vm.bookingItem.discount).toFixed(2)) +
                " " +
                _vm._s(_vm.currency) +
                " "
            )
          ]
        : _vm._e(),
      _vm.column === "organization_unit" &&
      _vm.bookingItem.organization_unit !== null
        ? [_vm._v(" " + _vm._s(_vm.bookingItem.organization_unit) + " ")]
        : _vm._e(),
      _vm.column === "airportCharges" &&
      _vm.bookingItem.airport_taxes_and_fees !== null
        ? [
            _vm._v(
              " " +
                _vm._s(
                  parseFloat(_vm.bookingItem.airport_taxes_and_fees).toFixed(2)
                ) +
                " " +
                _vm._s(_vm.currency) +
                " "
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }